export const two_decimal_places = /^[0-9]+(.[0-9]{2})?$/
export const telephoneReg = /0\d{2,3}-\d{7,8}/;
export const mobileReg = /^1\d{10}$/;